import React, { PropTypes, Component } from 'react'
import { withRouter } from 'react-router'
import { Colors, Fonts, Metrics } from '../../Themes'
import styled from 'styled-components'
import Burger from '../../svg-icons/Burger'
import BackArrow from '../../svg-icons/BackArrow'
import CloseIcon from '../../svg-icons/CloseIcon'
import DropdownLinkContainer from '../../components/DropdownLinkContainer'
import MobileStore from '../../stores/MobileStore'
import connectToStores from 'alt-utils/lib/connectToStores'

const NavbarContainer = styled.div`
  width: 100%;
  height: ${Metrics.components.navbarDefault};
  background-color: ${Colors.white};
  border-bottom: ${Metrics.borders.default};
  box-shadow: ${Metrics.shadows.default};
  display: inline-block;
  position: relative;
`

const ElementOutsideContainer = styled.div`
  display: ${props => (props.hideOnDesktop ? 'none' : 'inline-block')};
  height: ${Metrics.components.navbarDefault};
  padding-right: ${props => (props.border ? Metrics.margins.larger : 0)};
  ${props => props.border && `border-right: ${Metrics.borders.headerBorder}`};
  float: ${props => (props.right ? 'right' : 'left')};
  @media screen and (max-width: ${Metrics.breakpoints.tablet}) {
    display: ${props => (props.hideOnMobile ? 'none' : 'inline-block')};
  }
`

const ElementInsideContainer = styled.div`
  display: table;
  height: ${Metrics.components.navbarDefault};
  margin-right: ${props => (props.mgRight ? Metrics.margins.larger : 0)};
  margin-left: ${props => (props.mgLeft ? Metrics.margins.larger : 0)};
`

const Element = styled.div`
  display: table-cell;
  vertical-align: middle;
  cursor: pointer;
`

const MobileMenuContainer = styled.div`
  position: relative;
  display: none;

  @media screen and (max-width: ${Metrics.breakpoints.tablet}) {
    display: block;
  }
`

const MobileMenu = styled.div`
  position: absolute;
  top: 0;
  left: -100vw;
  background: ${Colors.white};
  width: ${Metrics.components.mobileMenu};
  height: 100vh;
  transition: ease left 0.5s;
  z-index: 6;

  @media screen and (max-width: ${Metrics.breakpoints.tablet}) {
    &.active {
      transition: ease left 0.5s;
      left: 0vw;
    }
  }
`

const CustomCloseIcon = styled(CloseIcon)`
  display: block;
  margin-top: ${Metrics.margins.base};
  margin-right: ${Metrics.margins.base};
  text-align: right;
`

const Overlay = styled.div`
  position: absolute;
  width: 100vw;
  height: 100vh;
  display: none;
  z-index: 6;
  transition: ease opacity 0.5s;

  @media screen and (max-width: ${Metrics.breakpoints.tablet}) {
    &.active {
      background: rgba(0, 0, 0, 0.5);
      transition: ease opacity 0.5s;
      display: block;
    }
  }
`

const LinkComponent = styled.div`
  cursor: pointer;
  display: inline-block;
  position: relative ${Fonts.style.Text};
  font-weight: ${Fonts.weight.normal};
  color: ${props => (props.active ? Colors.primary : Colors.black)};
  margin-top: ${Metrics.margins.larger};

  &:hover {
    color: ${Colors.primary};
  }

  &.active {
    color: ${Colors.primary};
  }
`

const MobileBurger = styled.div`margin-left: ${Metrics.margins.medium};`

const MobileBack = styled.div`margin-left: ${Metrics.margins.largeLarger};`

const MobileLogo = styled.div`
  width: calc(100vw - ${Metrics.components.navbarMobileLogoMargins});
  text-align: center;
`

const Links = styled.div`padding-left: ${Metrics.margins.large};`

class Navbar extends Component {
  constructor (props) {
    super(props)
    this.state = {
      activeDropdown: null
    }
    this.updateDimensions = this.updateDimensions.bind(this)
    this.mobileLinks = this.mobileLinks.bind(this)
    this.navBarLinks = this.navBarLinks.bind(this)
  }

  static getStores () {
    return [ MobileStore ]
  }

  static getPropsFromStores () {
    const mobileState = MobileStore.getState()
    return {
      backButton: mobileState.backButton
    }
  }

  componentDidMount () {
    window.addEventListener('resize', this.updateDimensions)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.updateDimensions)
  }

  updateDimensions () {
    this.setState({ activeDropdown: null })
  }

  mobileLinks () {
    const { links, activeDropdown, selectDropdown } = this.props
    return links.map((link, index) => {
      return (
        <DropdownLinkContainer
          key={`mobile-dropdown-links-${index}`}
          link={link}
          sublinks={link.sublinks}
          toggleDropdown={selectDropdown}
          open={activeDropdown === link.label}
        />
      )
    })
  }

  navBarLinks () {
    const { links, activeDropdown, selectDropdown } = this.props
    return links.map((link, index) => {
      return (
        <DropdownLinkContainer
          key={`dropdown-links-${index}`}
          link={link}
          sublinks={link.sublinks}
          toggleDropdown={selectDropdown}
          open={activeDropdown === link.label}
        />
      )
    })
  }

  render () {
    const {
      left,
      right,
      middle,
      logout,
      toggleMobileMenu,
      mobileMenuOpen,
      handleBlur,
      backButton,
      router
    } = this.props

    return (
      <NavbarContainer {...this.props} onBlur={handleBlur} tabIndex='-1'>
        <MobileMenuContainer>
          <Overlay
            className={mobileMenuOpen && 'active'}
            onClick={toggleMobileMenu}
          />
          <MobileMenu className={mobileMenuOpen && 'active'}>
            <CustomCloseIcon onClick={toggleMobileMenu} />
            <ElementInsideContainer>
              <Element>{middle}</Element>
            </ElementInsideContainer>
            <Links>
              {this.mobileLinks()}
              <LinkComponent logout onClick={logout}>
                Logout
              </LinkComponent>
            </Links>
          </MobileMenu>
        </MobileMenuContainer>
        <ElementOutsideContainer hideOnDesktop>
          <ElementInsideContainer>
            <Element>
              {backButton ? (
                <MobileBack>
                  <BackArrow onClick={() => router.goBack()} />
                </MobileBack>
              ) : (
                <MobileBurger>
                  <Burger onClick={toggleMobileMenu} />
                </MobileBurger>
              )}
            </Element>
          </ElementInsideContainer>
        </ElementOutsideContainer>
        <ElementOutsideContainer hideOnDesktop>
          <ElementInsideContainer>
            <Element>
              <MobileLogo>{left}</MobileLogo>
            </Element>
          </ElementInsideContainer>
        </ElementOutsideContainer>
        <ElementOutsideContainer hideOnMobile border>
          <ElementInsideContainer mgLeft>
            <Element>{left}</Element>
          </ElementInsideContainer>
        </ElementOutsideContainer>
        <ElementOutsideContainer hideOnMobile>
          <ElementInsideContainer>
            <Element>{middle}</Element>
          </ElementInsideContainer>
        </ElementOutsideContainer>
        <ElementOutsideContainer hideOnMobile border right>
          <ElementInsideContainer>
            <Element>{right}</Element>
          </ElementInsideContainer>
        </ElementOutsideContainer>
        <ElementOutsideContainer hideOnMobile right>
          <ElementInsideContainer>
            <Element>{this.navBarLinks()}</Element>
          </ElementInsideContainer>
        </ElementOutsideContainer>
      </NavbarContainer>
    )
  }
}

Navbar.propTypes = {
  left: PropTypes.node,
  middle: PropTypes.node,
  right: PropTypes.node,
  links: PropTypes.array,
  logout: PropTypes.func,
  toggleMobileMenu: PropTypes.func.isRequired,
  mobileMenuOpen: PropTypes.bool.isRequired,
  handleBlur: PropTypes.func,
  activeDropdown: PropTypes.string,
  selectDropdown: PropTypes.func
}

export default connectToStores(withRouter(Navbar))



// WEBPACK FOOTER //
// ./src/components/Navbar/index.js